import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/PDF_file_icon.svg'
import _imports_1 from '@/assets/images/Arrow_right.png'
import _imports_2 from '@/assets/images/Trash.png'


const _hoisted_1 = { class: "overflow-x-auto shadow mt-4 mb-[3%]" }
const _hoisted_2 = {
  class: "w-full border-[1px] text-left lg:text-xl",
  id: "offers_table"
}
const _hoisted_3 = {
  class: "text-center",
  id: "offers_body"
}
const _hoisted_4 = {
  class: "w-[5%] font-medium p-3",
  id: "body_ID"
}
const _hoisted_5 = {
  class: "w-[5%] font-medium p-3",
  id: "body_Stud"
}
const _hoisted_6 = {
  class: "w-[5%] font-medium p-3",
  id: "body_Doz"
}
const _hoisted_7 = {
  class: "w-[5%] font-medium p-3",
  id: "body_Relevanz"
}
const _hoisted_8 = {
  key: 0,
  class: "w-[5%] font-medium p-3",
  id: "body_PDF"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "w-[5%] font-medium p-3"
}
const _hoisted_11 = {
  class: "w-[15%] font-medium p-3",
  id: "body_Einrichtungskosten"
}
const _hoisted_12 = {
  class: "w-[10%] font-medium p-3",
  id: "body_Lizenzgebühren"
}
const _hoisted_13 = {
  class: "w-[35%] font-medium p-3",
  id: "body_Kommentar"
}
const _hoisted_14 = {
  class: "w-[15%] font-medium p-3",
  id: "body_Oeffnen"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]

import { useRoute } from 'vue-router'
    import { SelectedOffer } from '@/model/types'

    // Define the props with explicit types
    
export default /*@__PURE__*/_defineComponent({
  __name: 'OffersTable',
  props: {
        selectOfferMethod: Function,
        deleteMethod: Function,
        pdfMethod: Function,
        offers: Array as () => SelectedOffer[],
        hasLink: Function,
    },
  setup(__props) {

    const props = __props

    const route = useRoute()
    const contactId = route.params.id

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("thead", {
        class: "text-white text-center",
        id: "offers_head"
      }, [
        _createElementVNode("tr", { class: "border-b-[1px] border-black bg-[#545656] py-2" }, [
          _createElementVNode("th", {
            class: "w-[5%] font-medium p-3",
            id: "header_ID"
          }, "ID"),
          _createElementVNode("th", {
            class: "w-[5%] font-medium p-3",
            id: "header_Stud"
          }, "#Stud"),
          _createElementVNode("th", {
            class: "w-[5%] font-medium p-3",
            id: "header_Doz"
          }, "#Doz"),
          _createElementVNode("th", {
            class: "w-[5%] font-medium p-3",
            id: "header_Relevanz"
          }, "Relevanz"),
          _createElementVNode("th", {
            class: "w-[5%] font-medium p-3",
            id: "header_PDF"
          }, "PDF"),
          _createElementVNode("th", {
            class: "w-[15%] font-medium p-3",
            id: "header_Einrichtungskosten"
          }, " Einrichtungskosten "),
          _createElementVNode("th", {
            class: "w-[10%] font-medium p-3",
            id: "header_Lizenzgebühren"
          }, " Lizenzgebühren "),
          _createElementVNode("th", {
            class: "w-[35%] font-medium p-3",
            id: "header_Kommentar"
          }, "Kommentar"),
          _createElementVNode("th", {
            class: "w-[15%] font-medium p-3",
            id: "header_Oeffnen",
            colspan: "2"
          }, "Öffnen")
        ])
      ], -1)),
      _createElementVNode("tbody", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.offers, (offer) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: "border-b-2",
            key: offer.id
          }, [
            _createElementVNode("td", _hoisted_4, _toDisplayString(offer.id), 1),
            _createElementVNode("td", _hoisted_5, _toDisplayString(offer.numStudents), 1),
            _createElementVNode("td", _hoisted_6, _toDisplayString(offer.numTeachers), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(offer.relevance), 1),
            (offer.path)
              ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                  _createElementVNode("button", {
                    id: "pdf_button",
                    onClick: () => props.pdfMethod && props.pdfMethod(offer.id, _unref(contactId))
                  }, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "Open",
                      class: "lg:w-[35px] w-[20px]"
                    }, null, -1)
                  ]))], 8, _hoisted_9)
                ]))
              : (_openBlock(), _createElementBlock("td", _hoisted_10)),
            _createElementVNode("td", _hoisted_11, _toDisplayString(offer.set_up_price), 1),
            _createElementVNode("td", _hoisted_12, _toDisplayString(offer.edu_swiss_total), 1),
            _createElementVNode("td", _hoisted_13, _toDisplayString(offer.comments), 1),
            _createElementVNode("td", _hoisted_14, [
              _createElementVNode("button", {
                "data-cy": "select_button",
                onClick: ($event: any) => (
                                props.selectOfferMethod && props.selectOfferMethod(offer, _unref(contactId))
                            )
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("button", null, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "Open",
                    class: "lg:w-[35px] w-[20px]"
                  })
                ], -1)
              ]))], 8, _hoisted_15),
              (props.hasLink && props.hasLink('offer/delete_single'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    id: "delete_button",
                    onClick: 
                                () => props.deleteMethod && props.deleteMethod(_unref(contactId), offer.id)
                            ,
                    class: "ml-[25%]"
                  }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: "Del",
                      class: "lg:w-[35px] w-[20px]"
                    }, null, -1)
                  ]))], 8, _hoisted_16))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})